export default {
	NOMINAL: 'Nominal',
	PERCENTAGE: 'Percentage',
};
